import {Service, signal} from '@angular/core'


@Service()
export class RouteService {
  public readonly onHorseRoute = signal(false)
}